<template>
  <nav
    v-if="isFull"
    class="container display-flex flex-content-between"
    aria-label="Awesomeverse Products + Links"
  >
    <div class="display-flex">
      <site-link
        :to="{ name: 'home' }"
        class="product product-font-awesome product-active"
        aria-label="Font Awesome"
        @click="$posthog.capture('main_navigation_link_click', { destination: 'home' })"
      >
        <owa-logo-font-awesome />
      </site-link>

      <a
        id="product-web-awesome"
        href="https://webawesome.com"
        class="product product-web-awesome"
        aria-label="Web Awesome"
        data-balloon-pos="down"
        @click="$posthog.capture('product_nav_link_click', { destination: 'web_awesome' })"
      >
        <wa-icon
          name="web-awesome"
          family="brands"
          class="logo-icon logo-web-awesome"
        ></wa-icon>
      </a>
      <a
        id="product-build-awesome"
        href="https://www.kickstarter.com/projects/fontawesome/build-awesome-pro?ref=90rgxp"
        class="product product-build-awesome"
        aria-label="Build Awesome"
        data-balloon-pos="down"
        @click="$posthog.capture('product_nav_link_click', { destination: 'build_awesome' })"
      >
        <wa-icon
          src="/images/logo-build-awesome-icon.svg"
          class="logo-icon logo-build-awesome"
        ></wa-icon>
      </a>
    </div>

    <div
      class="nav-products-secondary display-flex"
      style="gap: var(--wa-space-2xs)"
    >
      <wa-button
        id="product-podcast-awesome"
        appearance="plain"
        href="https://www.podcastawesome.com"
        class="pseudo-product product-podcast-awesome"
        aria-label="Podcast Awesome"
        data-balloon-pos="down"
        @click="$posthog.capture('product_nav_link_click', { destination: 'podcast_awesome' })"
      >
        <font-awesome-icon
          :icon="$v7.solid.faPodcast"
          size="lg"
        />
      </wa-button>
      <wa-button
        id="product-blog-awesome"
        appearance="plain"
        href="https://blog.fontawesome.com"
        class="pseudo-product product-blog-awesome"
        aria-label="Blog Awesome"
        data-balloon-pos="down"
        @click="$posthog.capture('product_nav_link_click', { destination: 'blog_awesome' })"
      >
        <font-awesome-icon
          :icon="$v7.solid.faNewspaper"
          size="lg"
        />
      </wa-button>
    </div>
  </nav>

  <div
    v-else
    class="display-flex nav-products nav-products-drawer"
  >
    <site-link
      id="product-drawer-font-awesome"
      :to="{ name: 'home' }"
      class="display-flex flex-column flex-content-stretch product product-font-awesome product-active"
      aria-label="Font Awesome"
      @click="$posthog.capture('main_navigation_link_click', { destination: 'home', context: 'responsive_menu' })"
    >
      <wa-icon
        name="font-awesome"
        family="brands"
        class="logo-icon logo-font-awesome"
      ></wa-icon>
    </site-link>
    <a
      id="product-drawer-web-awesome"
      href="https://webawesome.com"
      class="display-flex flex-column flex-content-stretch product product-web-awesome"
      aria-label="Web Awesome"
      data-balloon-pos="down"
      @click="$posthog.capture('product_nav_link_click', { destination: 'web_awesome', context: 'responsive_menu' })"
    >
      <wa-icon
        name="web-awesome"
        family="brands"
        class="logo-icon logo-web-awesome"
      ></wa-icon>
    </a>
    <a
      id="product-drawer-build-awesome"
      href="https://www.kickstarter.com/projects/fontawesome/build-awesome-pro?ref=90rgxp"
      class="display-flex flex-column flex-content-stretch product product-build-awesome"
      aria-label="Build Awesome"
      data-balloon-pos="down"
      @click="$posthog.capture('product_nav_link_click', { destination: 'build_awesome', context: 'responsive_menu' })"
    >
      <wa-icon
        src="/images/logo-build-awesome-icon.svg"
        class="logo-icon logo-build-awesome"
      ></wa-icon>
    </a>
  </div>
</template>

<script>
  import '@web.awesome.me/webawesome-pro/dist/components/icon/icon.js'
  import '@web.awesome.me/webawesome-pro/dist/components/button/button.js'
  export default {
    name: 'PageHeaderProducts',

    props: {
      isFull: {
        type: Boolean,
        default: true
      }
    }
  }
</script>
